export default __webpack_public_path__ + "static/media/logo-bicentenario.74b26d54.png";